import { IAPIRoutes } from "../../../../config";

/**
 * Device Orders repository.
 *
 * Auth headers are injected automatically by `apiProvider.getDefaultHeaders()`
 * for `/patient-centric-app-v2/...` routes — we deliberately do NOT pass an
 * `Authorization` header here (see cip-rules.mdc).
 */
export const DeviceOrdersRepositoryFactory = ({
  APIProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  APIRoutes: IAPIRoutes;
}): IDeviceOrdersRepository => {
  const { GET, POST, PATCH, DELETE } = APIProvider;

  const list: IDeviceOrdersRepository["list"] = (payload) =>
    GET(
      APIRoutes.apiDeviceOrders.replace(
        "{clinic_id}",
        payload.clinic_id.toString()
      ),
      {}
    );

  const create: IDeviceOrdersRepository["create"] = (payload) => {
    const url = APIRoutes.apiDeviceOrders.replace(
      "{clinic_id}",
      payload.clinic_id.toString()
    );

    const body: Record<string, unknown> = {
      recipient_name: payload.recipient_name,
      recipient_address: payload.recipient_address,
    };
    if (payload.instructions !== undefined) {
      body.instructions = payload.instructions;
    }
    if (payload.tracker_url !== undefined) {
      body.tracker_url = payload.tracker_url;
    }
    if (payload.patient_id !== undefined) {
      body.patient_id = payload.patient_id;
    }
    if (payload.status !== undefined) {
      body.status = payload.status;
    }

    return POST(url, body);
  };

  const update: IDeviceOrdersRepository["update"] = (payload) => {
    const url = APIRoutes.apiDeviceOrderById
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{order_id}", payload.order_id.toString());

    const body: Record<string, unknown> = {};
    if (payload.recipient_name !== undefined) {
      body.recipient_name = payload.recipient_name;
    }
    if (payload.recipient_address !== undefined) {
      body.recipient_address = payload.recipient_address;
    }
    if (payload.instructions !== undefined) {
      body.instructions = payload.instructions;
    }
    if (payload.tracker_url !== undefined) {
      body.tracker_url = payload.tracker_url;
    }
    if (payload.patient_id !== undefined) {
      body.patient_id = payload.patient_id;
    }
    if (payload.status !== undefined) {
      body.status = payload.status;
    }

    return PATCH(url, body);
  };

  const remove: IDeviceOrdersRepository["remove"] = (payload) => {
    const url = APIRoutes.apiDeviceOrderById
      .replace("{clinic_id}", payload.clinic_id.toString())
      .replace("{order_id}", payload.order_id.toString());

    return DELETE(url);
  };

  return {
    list,
    create,
    update,
    remove,
  };
};
